export const ACCOUNT_TYPES = {
  CASH: 'CASH',
  BANK: 'BANK',
  CREDIT: 'CREDIT',
  GOAL: 'GOAL',
  INVESTMENT: 'INVESTMENT',
  LOAN: 'LOAN',
};
